module.exports = __webpack_public_path__ + "img/bg_login_L.73d2d325.png";